import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import { useAuth } from '@/hooks/useAuth';

interface Location {
  id: string;
  name: string;
  organization_id: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  phone?: string;
  created_at: string;
}

export const useLocations = () => {
  const { user } = useAuth();
  const organizationId = user?.user_metadata?.organization_id;

  return useQuery({
    queryKey: ['locations', organizationId],
    queryFn: async () => {
      if (!organizationId) {
        throw new Error('Organization ID is required');
      }

      const { data, error } = await supabase
        .from('locations')
        .select('*')
        .eq('organization_id', organizationId)
        .order('name');

      if (error) throw error;

      return { 
        data: data as Location[] 
      };
    },
    enabled: !!organizationId
  });
}; 